import React from 'react'
import Image from '../image'

// 创建无状态组件
const Gallery = (props) => {
  // 上一个 / 下一个
  function slide(e, direction='prev') {
    const gallery = $(e.target).parents('.gallery-wrapper').find('.gallery')
    const visibleItem = gallery.find('li:visible:first')
    const translateX = direction === 'prev' ? gallery.offset().left - visibleItem.width() : gallery.offset().left + visibleItem.width()
    gallery.css({
      transform: `translateX(${translateX}px)`
    })
  }
  //
  return (
    <div className="gallery-wrapper">
      <div className="gallery-control left" onClick={(e) => slide(e, 'prev')}>
        <i className="fi fi-arrow-left"> </i>
      </div>
      <div className="gallery-control right" onClick={(e) => slide(e, 'next')}>
        <i className="fi fi-arrow-right"> </i>
      </div>
      <ul className="gallery">
        {props.items.map((item, index) =>
          <li key={index}>
            <Image { ...item } caption={ item.caption || item.description } />
          </li>
        )}
      </ul>
    </div>
  )
}

export default Gallery


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/media/gallery/index.js